export default "__VITE_ASSET__CCg9rnKC__"